import * as React from "react";
import { Button } from "@grandvisionhq/common";
import { Heading } from "@grandvisionhq/elements";
import { Form, RequiredFieldsLabel, FirstName, LastName, Email, PhoneNumber, Util, FormControl, TextArea } from "@grandvisionhq/forms";
import { useIntl } from "@grandvisionhq/state";
import Consent from "../../Consent/Consent/Consent.js";
import TopicListContainer from "../../TopicList/TopicList/TopicListContainer.js";
/* empty css                         */
const consents = [
  {
    title: "customersupport.consent.userAgreement",
    value: "userAgreement",
    required: true
  }
];
const CustomerSupportForm = ({
  isLoading,
  labels,
  onSubmit,
  isCustomerIDActivated,
  showConsent
}) => {
  const { getLabel } = useIntl();
  return /* @__PURE__ */ React.createElement("section", { className: "customer-support-form__wrapper" }, /* @__PURE__ */ React.createElement(
    Heading,
    {
      className: "customer-support-form__heading",
      component: "h2",
      variant: "small",
      align: "left"
    },
    labels.title
  ), /* @__PURE__ */ React.createElement(
    Form,
    {
      name: "customer-support-form",
      className: "customer-support-form",
      onSubmit,
      "data-t": "customer-support-form",
      showErrorsOnInvalidSubmit: true
    },
    /* @__PURE__ */ React.createElement(RequiredFieldsLabel, { className: "customer-support-form__required-fields" }),
    /* @__PURE__ */ React.createElement(
      FirstName,
      {
        label: labels.firstName.label,
        errorMessage: labels.firstName.errorMessage,
        placeholder: labels.firstName.placeholder,
        required: true,
        "data-t": "first-name"
      }
    ),
    /* @__PURE__ */ React.createElement(
      LastName,
      {
        label: labels.lastName.label,
        errorMessage: labels.lastName.errorMessage,
        placeholder: labels.lastName.placeholder,
        required: true,
        "data-t": "last-name"
      }
    ),
    /* @__PURE__ */ React.createElement(
      Email,
      {
        label: labels.email.label,
        errorMessage: labels.email.errorMessage,
        placeholder: labels.email.placeholder,
        required: true,
        "data-t": "email"
      }
    ),
    /* @__PURE__ */ React.createElement(
      PhoneNumber,
      {
        required: true,
        label: labels.phoneNumber.label,
        errorMessage: labels.phoneNumber.errorMessage,
        placeholder: labels.phoneNumber.placeholder,
        validations: [Util.validations.isRequired, Util.validations.isNumber],
        "data-t": "phone-number"
      }
    ),
    isCustomerIDActivated && /* @__PURE__ */ React.createElement(
      FormControl,
      {
        required: false,
        label: labels.customerID.label,
        errorMessage: labels.customerID.errorMessage,
        placeholder: labels.customerID.placeholder,
        id: "customerID",
        "data-t": "customer-id",
        maxLength: 250
      }
    ),
    /* @__PURE__ */ React.createElement(
      TopicListContainer,
      {
        label: labels.topicList.label,
        errorMessage: labels.topicList.errorMessage,
        placeholder: labels.topicList.placeholder,
        validations: [Util.validations.isRequired],
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      TextArea,
      {
        required: true,
        label: labels.description.label,
        errorMessage: labels.description.errorMessage,
        placeholder: labels.description.placeholder,
        maxLength: 3e3,
        name: "description",
        validations: [Util.validations.isRequired],
        "data-t": "description"
      }
    ),
    showConsent && /* @__PURE__ */ React.createElement(
      Consent,
      {
        className: "customer-support-form__spacing-bottom",
        errorMessage: getLabel("customersupport.consents.error"),
        consents
      }
    ),
    /* @__PURE__ */ React.createElement(
      Button,
      {
        caption: labels.submitButtonLabel,
        className: "customer-support-form__button",
        "data-t": "submit-button",
        isLoading,
        type: "submit"
      }
    )
  ));
};
export {
  consents,
  CustomerSupportForm as default
};
//# sourceMappingURL=CustomerSupportForm.js.map
